/**
 * Where a client was created from, kept free of runtime dependencies so
 * contract tooling can load it without a database client. Frozen wire format.
 */
export const CLIENT_SOURCE_VALUES = [
  'HAPANA',
  'WEB',
  'APP',
  'STAFF',
  'KIOSK',
  'AGGREGATOR',
  'MIGRATION_IMPORTED',
  'APP_WEB_SIGNUP',
  'BUSINESS_ADDED',
  'EMBED_CREATED',
  'THIRD_PARTY',
  'CLIENT_REFERRAL',
  'SOCIAL_MEDIA',
] as const
